import DataSource from 'automation-ui-formula-editor/fetch-object-panel/containers/DataSource';
import DataSourceSkeleton from 'automation-ui-formula-editor/fetch-object-panel/components/DataSourceSkeleton';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const SelectDataSourceFetchObjects = ({
  onRemove,
  onEdit,
  dataSourceDefinition,
  loading,
  dataSourceErrored
}) => {
  if (loading) {
    return /*#__PURE__*/_jsx(DataSourceSkeleton, {});
  }
  if (dataSourceErrored) {
    return /*#__PURE__*/_jsx(Text, {
      color: "icon-primary-default",
      fontStyle: "italic",
      paddingInlineStart: "400",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-formula-editor.fetch-object-panel.error.data-source-errored"
      })
    });
  }
  const children = dataSourceDefinition.children || [];
  if (dataSourceDefinition.children.length === 0) {
    return /*#__PURE__*/_jsx(Text, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-formula-editor.data-passing-panel.property-select-mode.select-data-source-panel.label.no-additional-records"
      })
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children.map(child => {
      const {
        toDataSource
      } = child;
      return /*#__PURE__*/_jsx(DataSource, {
        dataSourceToView: {
          prefix: toDataSource
        },
        onRemove: onRemove,
        onEdit: onEdit
      }, toDataSource);
    })
  });
};
export default SelectDataSourceFetchObjects;